import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class JurisdictionFeeService extends AbstractService {
	static endpoint = ENDPOINTS.jurisdictionFees;

	static jurisdictionFeeApi = NexusService.jurisdictionFeesApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_jurisdiction_fees";

	static getAll({ abortSignal } = {}) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.jurisdictionFeeApi
				.getJurisdictionFees({}, { signal: abortSignal })
				.then(response => ({ data: response }));
		}

		return this.get({
			endpoint: this.endpoint,
			abortSignal,
		});
	}

	static save(data) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.jurisdictionFeeApi
				.updateJurisdictionFees({ jurisdictionFeesUpdatePayload: data })
				.then(response => ({ data: response }));
		}

		return this.post({
			endpoint: this.endpoint,
			data,
		});
	}
}
